export const deepClone = (obj) => {
    let objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
      for (let key in obj) {
        if (obj[key] && typeof obj[key] === "object") {
          objClone[key] = deepClone(obj[key]);
        } else {
          objClone[key] = obj[key];
        }
      }
    }
    return objClone;
  }
  export const copyToClipboard = (content)=> {
    if (window.clipboardData) {
      window.clipboardData.setData('text', content);
    } else {
      (function (content) {
        document.oncopy = function (e) {
          e.clipboardData.setData('text', content);
          e.preventDefault(); //取消事件的默认动作
          document.oncopy = null;
        }
      })(content);
      document.execCommand('Copy');
    }
  }

  export const strLength = (data) => {
    var realLength = 0, len = data.length, charCode = -1;
    for (var i = 0; i < len; i++) {
      charCode = data.charCodeAt(i);
      if (charCode >= 0 && charCode <= 128) realLength += 1;
      else realLength += 2;
    }
    return realLength;
  }

export const testEfficacy = (option) => {
  const defaultOptions = {
    effective: () => {},
    loseEfficacy: () => {}
  }
  option = {
    ...defaultOptions,
    ...option
  }
  if(localStorage.getItem('wattingTime')){
    let watTime = parseInt(localStorage.getItem('wattingTime'))
    let curTimr = Date.now()
    let chaTime = 30 * 60 * 1000
    if(curTimr-watTime > chaTime){
      option.loseEfficacy()
    }else{
      option.effective()
    }
  }else{
    option.loseEfficacy()
  }
}
